import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67a773b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommentaryPanel = _resolveComponent("CommentaryPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preList, (commentary, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: _ctx.problemId + 'post' + index,
        class: _normalizeClass({ 'mb-6': index !== _ctx.preList.length - 1 })
      }, [
        _createVNode(_component_CommentaryPanel, {
          bindCommentary: _ctx.bindCommentary,
          commentary: commentary,
          icon: 'live_help',
          panelIndex: index,
          selectedIndex: _ctx.commentaryPageStatePresenter.preCommentarySelectedList.value[commentary.type] ?? 0
        }, null, 8, ["bindCommentary", "commentary", "panelIndex", "selectedIndex"])
      ], 2))
    }), 128))
  ]))
}